/**
* @file 运营中心-数据备份
* */
<template>
  <div id="backup">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane name="driverBackup">
        <template slot="label"><i class="el-icon-user" style="margin-right:4px"></i>司机数据</template>
        <driverBackup v-if="show" />
      </el-tab-pane>
      <el-tab-pane name="second">
        <template slot="label"><i class="el-icon-truck" style="margin-right:4px"></i>车辆数据</template>
        <vehicleBackup v-if="show" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "backup",
  components: {
    driverBackup: () => import("@/page/resource/driver/driverBackup.vue"),
    vehicleBackup: () => import("@/page/resource/vehicle/vehicleBackup.vue")
  },
  data() {
    return {
      tabs: [],
      tabAction: 'driverBackup',
      show: false,
    };
  },
  mounted() {
    this.show = true;
  },
};
</script>

<style lang="less">
#backup {
  height: 100%;

  .el-tabs {
    height: 100%;
    &__content {
      height: calc(100% - 40px);
    }
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
